import { KeyboardEventHandler } from "react";
import { CheckedInput, Container, ExtraOfferPrice, ExtraPrice, InfoItem, InfoList, Input, OfferContainer, OfferContainerDark, OfferLabel, OfferText, Price, PriceContainer, PriceDefinition, ProductCard, ProductCardContainer, Title, TopContainer } from "./ProductCardV2.style";
import { BiCheck } from "react-icons/bi";


interface Props {
    title: string | undefined;
    price: string | undefined;
    extraPrice?: string;
    extraOfferPrice?: string;
    offerText?: string;
    bottomOfferText?: string;
    hasOffer?: boolean;
    info?: Array<any>;
    removekrPerMonth?: boolean;
    onClick?: () => void;
    isChecked: boolean;
    onKeyDown: KeyboardEventHandler<HTMLDivElement>;
}

export default function ProductCardV2({title, price, extraPrice, extraOfferPrice, offerText, bottomOfferText, hasOffer, info, onClick, isChecked = false, onKeyDown, removekrPerMonth}: Props) {
    return (
        <Container>
            <ProductCardContainer isChecked={isChecked}>
            {hasOffer && offerText && offerText != "" && (
                <OfferContainer>
                    <OfferText>{offerText}</OfferText>
                    <OfferLabel>Tilbud</OfferLabel>    
                </OfferContainer>
            )}
                <ProductCard onClick={onClick} isChecked={isChecked} tabIndex={0} onKeyDown={onKeyDown} hasOffer={hasOffer} hasBottomOffer={isChecked && bottomOfferText ? true : false}>
                    <TopContainer>
                        <Input isChecked={isChecked}>
                            {isChecked && (<CheckedInput/>)}
                        </Input>
                        <Title>{title}</Title>
                    </TopContainer>
                    <InfoList>
                        {info?.map((item) => {       
                            return (<InfoItem id={item.key} key={item.key}>{item.description}</InfoItem>) 
                        })}
                    </InfoList>
                    <PriceContainer>
                        {extraOfferPrice && (
                        <ExtraOfferPrice>
                            {extraOfferPrice}
                        </ExtraOfferPrice>
                        )}
                        <Price>
                            {price} {!removekrPerMonth && (<PriceDefinition> kr./md.</PriceDefinition>)}
                        </Price>
                        {extraPrice && 
                        <ExtraPrice>
                            {extraPrice}
                        </ExtraPrice>
                        }
                    </PriceContainer>
                </ProductCard>
            {isChecked && bottomOfferText && (
                <OfferContainerDark>
                    {bottomOfferText}
                </OfferContainerDark>
            )}
            </ProductCardContainer>
        </Container>
    )
}